import { types } from 'mobx-state-tree';
export const OrganizationStats = types.model({
  totalFields: types.maybeNull(types.number),
  totalFieldsArea: types.maybeNull(types.number),
  totalCropzonesArea: types.maybeNull(types.number),
  totalFieldsPerCountry: types.maybeNull(types.map(types.number))
});